import React from 'react';
import Lozenge from '@atlaskit/lozenge';

type DraftStatusLozengeProps = {
  isCompact?: boolean;
};

const DraftStatusLozenge: React.FC<DraftStatusLozengeProps> = ({ isCompact }) => (
  <Lozenge appearance="moved">{isCompact ? '' : `🛠 `}Draft</Lozenge>
);

export default DraftStatusLozenge;
